const PipsTerminalContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Explore Every Market from One Platform</h2>

                <p>
                  The Pips Terminal gives you access to a full spectrum of
                  assets across global markets.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/pips_terminal/pips_terminal_3.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade over 60 major, minor, and exotic pairs with ultra-tight
                spreads and precise order control.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Crypto</h3>
              <p>
                Buy, sell, and hold digital currencies securely with real-time
                pricing and instant execution.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Stocks</h3>
              <p>
                Invest in top global companies with transparent fees and
                detailed equity analytics.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Commodities</h3>
              <p>
                Diversify your strategy with gold, oil, and other key
                commodities that move global markets.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTerminalContentFour;
